import {Form} from "rsuite";
import React from "react";

const ExperienceSearchForm = () => {

    return (
        <Form.Group>
            <Form.ControlLabel>Company</Form.ControlLabel>
            <Form.Control name="company"
                          style={{width: 400}}
            />
        </Form.Group>
    );
};

export default ExperienceSearchForm;